export default {
  starPromotions: {
    display: 'block',
    fontSize: '12px',
    marginBottom: '3px'
  },
  headerTitleNumber: {
    color: 'fff',
    fontSize: '6px'
  },
  luxury: {
    fontSize: '3px'
  },
  defaultStyle: {
    fontSize: '12px',
    "&:after[stars='6*'], &:after[stars='5GL']": {
      font: data => '13px' + data.fontFamily1,
      verticalAlign: 'bottom',
      color: data => data.mainColor,
      content: "'GL'"
    }
  },
  starsFont : {
    fontSize:'14px',
    '& > span':{
      fontSize:'14px'
    }
  }
};
